import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {Container, Card, Grid, Button, Icon, Input, GridRow, Tab} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../../common/constants/datesFormat';
import {AccesoriesRequestsTable} from './accessoriesRequestsTable';
import {AccessoriesRequestDetailsTable} from './accessoriesRequestDetailsTable';
import AccessoriesDeliveryConfirmationModal from './accessoriesDeliveryConfirmationModal';
import fscreen from 'fscreen';

const {
  navigateTo,
  fetchAccessoriesRequests,
  cleanAccessoriesRequestsList,
} = Actions;

const FILTER_INITIAL_STATE = {
  'dateFrom': '',
  'dateTo': '',
  'request': '',
  'delivered': 'N',
  'groupBy': 'req',
};

const Index = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [filterState, setFilterState] = useState(FILTER_INITIAL_STATE);
  const [detailCardVisible, setDetailCardVisible] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedRequestDetails, setSelectedRequestDetails] = useState([]);
  const loading = useSelector((state) => state.accessoriesRequests.loading);
  const accessoriesRequests = useSelector((state) => state.accessoriesRequests.list);
  const dispatch = useDispatch();

  const handler = () => {
    if (!fscreen.fullscreenElement) {
      setIsFullScreen(false);
    }
  };

  const changeFullScreenListener = () => {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener('fullscreenchange', handler.bind(this), false);
    }
  };

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.AccessoriesRequest, scopes.See) &&
      !hasAccessPermission(permissions, resources.AccessoriesRequest, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    changeFullScreenListener();
    // dispatch(fetchAccessoriesRequests());
  }, [dispatch]);

  const toggleFullScreen = () => {
    if (!fscreen.fullscreenElement) {
      fscreen.requestFullscreen(document.documentElement);
      setIsFullScreen(true);
    } else {
      fscreen.exitFullscreen();
      setIsFullScreen(false);
    }
  };

  const icon = isFullScreen ? 'compress' : 'expand';

  const handleOnChangeValues = (value, field) => {
    switch (field) {
      case 'dateFrom':
        setFilterState({...filterState, 'dateFrom': value ? moment(value).format(noTimeZoneShortISODate) : ''});
        break;
      case 'dateTo':
        setFilterState({...filterState, 'dateTo': value ? moment(value).format(noTimeZoneShortISODate) : ''});
        break;
      case 'request':
        setFilterState({...filterState, 'request': value});
        break;
      case 'delivered':
        setFilterState({...filterState, 'delivered': value});
        break;
      default:
        break;
    }
  };

  const handleTabChange = (e, tab) => {
    e.preventDefault();
    const delivered = tab.activeIndex === 1 ? 'S' : 'N';
    dispatch(cleanAccessoriesRequestsList());
    handleOnChangeValues(delivered, 'delivered');
    setSelectedRequest(null);
    setSelectedRequestDetails([]);
  };
  const handleRequestChange = (e, value) => {
    e.preventDefault();
    handleOnChangeValues(value, 'request');
  };

  useEffect(() => {
    dispatch(fetchAccessoriesRequests(filterState));
  }, [filterState]);

  useEffect(() => {
    setSelectedRequest(null);
    setSelectedRequestDetails([]);
  }, [accessoriesRequests]);

  const groupBy = function(xs, keyBy) {
    const helper = {};
    const result = xs.reduce(function(r, o) {
      const key = o[keyBy];
      if (!helper[key]) {
        helper[key] = Object.assign({}, o);
        r.push(helper[key]);
      } else {
        helper[key].quantity += o.quantity;
      }
      return r;
    }, []);
    return result;
  };

  const handleDetailsCard = (request) => {
    if (detailCardVisible && selectedRequest === request) {
      setDetailCardVisible(false);
      setSelectedRequest(null);
      setSelectedRequestDetails([]);
      return;
    }
    setDetailCardVisible(true);
    setSelectedRequest(request);
    const requestDetails = groupBy(accessoriesRequests.filter((item) => item.request === request), 'accessory');
    setSelectedRequestDetails(requestDetails);
  };

  const renderAccessoriesRequestsTable = () => {
    const requestsList = [...new Set(accessoriesRequests.map((item) => item.request))]
      .map((request) => ({
        ...accessoriesRequests.find((x) => x.request === request),
        'vehicles': [...new Set(
          accessoriesRequests.filter((x) => x.request === request).map((x) => x.chassis)
        )],
      }));
    return <Tab.Pane>
      <AccesoriesRequestsTable loading={loading} accessoriesRequests={requestsList}
        handleDetailsCard={handleDetailsCard} selectedRequest={selectedRequest} />
    </Tab.Pane>;
  };

  return (
    <Container fluid>
      <Card raised fluid>
        <div className='title-bar'>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div className='title'>
                  <h2>Control de pedidos de accesorios</h2>
                </div>
              </Grid.Column>
              <Grid.Column textAlign='right'>
                <Icon link name={icon} size='big'
                  onClick={toggleFullScreen.bind(this)} />
                <Link to={paths.AccessoriesRequestSummary}>
                  <Button primary>Ir a Resumen por Accesorios</Button>
                </Link>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={5}>
              <Grid.Column>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4} textAlign='right'>
                      <label><h4>Desde:</h4></label>
                    </Grid.Column>
                    <Grid.Column width={12}>
                      <DatePicker locale='es' dateFormat={dateFormatPicker} todayButton='Hoy'
                        customInput={<Input readOnly icon='calendar' size='small' />}
                        selected={filterState.dateFrom ?
                          moment(filterState.dateFrom).toDate() : null}
                        onChange={(value) => handleOnChangeValues(value, 'dateFrom')}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4} textAlign='right'>
                      <label><h4>Hasta:</h4></label>
                    </Grid.Column>
                    <Grid.Column width={12}>
                      <DatePicker locale='es' dateFormat={dateFormatPicker} todayButton='Hoy'
                        customInput={<Input readOnly icon='calendar' size='small' />}
                        selected={filterState.dateTo ?
                          moment(filterState.dateTo).toDate() : null}
                        onChange={(value) => handleOnChangeValues(value, 'dateTo')}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={4} textAlign='right'>
                      <label><h4>Pedido:</h4></label>
                    </Grid.Column>
                    <Grid.Column width={12}>
                      <Input placeholder='PFA1000' value={filterState.request}
                        onChange={(e, input) => handleRequestChange(e, input.value)}></Input>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Card raised fluid>
        <Grid padded>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={9} computer={9} textAlign='left'>
              <Grid columns={3}>
                <GridRow columns={1}>
                  <Grid.Column>
                    <Tab onTabChange={(e, value) => handleTabChange(e, value)} panes={[
                      {'menuItem': 'Pendientes', 'render': () => renderAccessoriesRequestsTable()},
                      {'menuItem': 'Despachados', 'render': () => renderAccessoriesRequestsTable()},
                    ]}></Tab>
                  </Grid.Column>
                </GridRow>
              </Grid>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={7} computer={7}>
              {
                <Card raised fluid
                  style={{
                    'height': '100%',
                    'maxHeight': '600px',
                    'overflowY': 'auto',
                    'overflowX': 'hidden',
                  }}>
                  <>
                    <div className='title-bar'>
                      <Grid textAlign='left' verticalAlign='middle'>
                        <Grid.Row>
                          <Grid.Column width={10}>
                            <h3>Detalle del pedido de accesorios</h3>
                          </Grid.Column>
                          <Grid.Column width={6} textAlign='right'>
                            <AccessoriesDeliveryConfirmationModal request={selectedRequest} filterState={filterState}
                              disabled={selectedRequest ? (filterState.delivered === 'S' ? true : false) : true} />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </div>
                    {detailCardVisible ?
                      <div style={{'padding': '14px', 'marginTop': '14px'}}>
                        <AccessoriesRequestDetailsTable loading={loading}
                          accessoriesRequestDetails={selectedRequestDetails} setSelectedRequest={selectedRequest} />
                      </div> : ''}
                  </>
                </Card>
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    </Container>
  );
};

export default Index;
